import type {
  ArtGroupEnum,
  DataPaginationResponse_ArtShortSerializer_,
  PaginationResponse_ArtShortSerializer_,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { TagsType } from "../constants";

interface IAbonementExclusivesParams {
  limit?: number;
  offset?: string;
  art_groups?: number[];
}

interface IGetArtsParams {
  art_groups: ArtGroupEnum[];
  o?: "popular" | "new";
  offset?: number;
  limit?: number;
}

export const artsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getAbonementExclusiveArts: build.query<
      DataPaginationResponse_ArtShortSerializer_,
      IAbonementExclusivesParams
    >({
      query: params => ({
        url: "/foundation/api/arts/abonement-exclusives",
        params,
      }),
      transformResponse: (response: PaginationResponse_ArtShortSerializer_) =>
        response.payload,
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST],
    }),
    getArts: build.query<
      DataPaginationResponse_ArtShortSerializer_,
      IGetArtsParams | void
    >({
      query: params => ({
        url: "/foundation/api/arts",
        params,
      }),
      transformResponse: (response: PaginationResponse_ArtShortSerializer_) =>
        response.payload,
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST],
    }),
  }),
});
